<template>
    <div class="sidebar-wrapper">
        <div class="sidebar shadow-sm p-2 m-0">
            <div class="sidebar-top">
                <!-- <button @click="triggerSaveEvent" v-if="onOrderPage && !readOnlyOrder" class="save-btn btn btn-primary"> Save </button>
                <button @click="goToMostRecentOrder" class="icon-btn">
                    <i class="fa fa-forward" aria-hidden="true"></i>
                </button>
                <router-link :to="{ name: 'DashboardHome'       }"><i class="fa fa-file-invoice-dollar" title="home" aria-hidden="true"></i></router-link> -->

                <template v-if="can('access-admin-sidebar')">
                    <router-link :to="{ name: 'ManufacturerSearch'  }"><i class="fa fa-tools" title="Manufacturer Search" aria-hidden="true"></i></router-link>
                    <router-link :to="{ name: 'DealerSearch'        }"><i class="fa fa-building" title="Dealer Search" aria-hidden="true"></i></router-link>
                    <!-- <router-link :to="{ name: 'CustomerSearch'      }"><i class="fa fa-handshake" title="Customer Search" aria-hidden="true"></i></router-link> -->
                    <!-- <router-link :to="{ name: 'CoworkerSearch'      }"><i class="fa fa-users" title="Coworker Search" aria-hidden="true"></i></router-link> -->
                    <!-- <router-link :to="{ name: 'ProductSearch'       }"><i class="fa fa-file" title="Product Search" aria-hidden="true"></i></router-link> -->
                    <router-link :to="{ name: 'AdminUsers'          }"><i class="fa fa-user-plus" title="Admin Management" aria-hidden="true"></i></router-link>
                    <!--<router-link :to="{ name: 'AdminAlertMessage'          }"><i class="fa fa-comments" title="In app message alert" aria-hidden="true"></i></router-link>-->
                    <router-link :to="{ name: 'AdminAlertMessage'          }"><i class="fa fa-comments" title="In app message alert" aria-hidden="true"></i></router-link>
                </template>

                <template v-if="can('access-tenant-sidebar')">
                    <button @click="triggerSaveEvent" v-if="onOrderPage && !readOnlyOrder" class="save-btn btn btn-primary"> Save </button>
                    <button @click="goToMostRecentOrder" class="icon-btn">
                        <i class="fa fa-forward" aria-hidden="true"></i>
                    </button>
                    <router-link :to="{ name: 'DashboardHome'       }" class="home-link">
                        <img src="/home.svg" alt="home" title="home" class="sidebar-icon-img" />
                    </router-link>
                    <router-link v-if="!isLimitedTransferUser" :to="{ name: 'CustomerSearch'      }"><i class="fa fa-handshake" title="Customer Search" aria-hidden="true"></i></router-link>
                    <router-link v-if="!isLimitedTransferUser" :to="{ name: 'CoworkerSearch'      }"><i class="fa fa-users" title="Colleague Search" aria-hidden="true"></i></router-link>
                    <router-link v-if="!isLimitedTransferUser" :to="{ name: 'ManufacturerSearch'  }"><i class="fa fa-tools" title="Manufacturer Search" aria-hidden="true"></i></router-link>
                </template>
                <!-- <template v-if="can('access-tenant-user-admin')">
                    <router-link :to="{ name: 'ManufacturerSearch'  }"><i class="fa fa-tools" title="Manufacturer Search" aria-hidden="true"></i></router-link>
                </template> -->
                <template v-if="can('access-tenant-sidebar')">
										<router-link v-if="!isLimitedTransferUser" :to="{ name: 'ProductSearch'       }"><i class="fa fa-file" title="Product Search" aria-hidden="true"></i></router-link>
                </template>

                <template v-if="can('access-tenant-user-admin')">
                    <router-link :to="{ name: 'DealerUsers', params: { id: currentUser.DealerId }}"><i class="fa fa-user-plus" title="User Management" aria-hidden="true"></i></router-link>
                </template>
                <template v-if="can('access-tenant-sidebar')">
                    <button @click="toggleDealerIconNav" class="icon-btn" title="Favorites">
                        <i class="far fa-star" aria-hidden="true"></i>
                    </button>
                </template>
            </div>
            <div class="sidebar-bottom">
						<div :class="newsIconClass" @click="onNewsClick" title="News" :key="newsIconKey"><i class="fa fa-newspaper" aria-hidden="true"></i></div>
            <a class="icon-btn pointer" href="http://dentacad.com/Support" target="_blank"><i class="fa fa-question-circle" title="Documentation" aria-hidden="true"></i></a>
            <a class="icon-btn pointer"	href="#" onClick="MyWindow=window.open('http://dentacad.com/Support/HelpDeskRequest.html','MyWindow','width=625,height=650'); return false;">
							<i class="fa fa-ticket-alt" title="Contact Support" aria-hidden="true"></i></a>
            </div>

        </div>

        <div v-if="can('access-tenant-sidebar') && dealerIconNavOpen" class="favorites shadow-sm p-2 m-0">
            <div class="sidebar-top" :key="favoritesKey">
                <h4>Favorites</h4>
                <template v-if="can('access-tenant-sidebar') && dealerIconNavOpen">
                    <div v-for="favorite in favorites" :key="favorite.OrderId" class="favorite-item" @click="navigateToFavorite(favorite)">
											<span style="font-weight: 600;">{{ favorite.OrderNumber }}</span>&nbsp;{{`${favorite.WorksheetName ? '('+favorite.WorksheetName + ')' : ''}` }}
                    </div>
                </template>
            </div>
        </div>
  </div>
</template>

<script>
    import { mapState } from 'vuex';
    import { DealerService, OrderService, UserService } from '@/services';

    export default {
      data: () => {
         return {
            customIcons: [],
            dealerIconNavOpen: false,
            isLimitedTransferUser: true,
            favoritesKey: 0,
						newsIconKey: 0,
         }
      },
      computed: {
          ...mapState(['currentUser', 'customerJdeNumber', 'currentOrderNumber', 'currentOrderReadOnly', 'isPrivateCustomer', 'favorites']),
          onOrderPage(){
              return this.$route.name === 'CustomerOrder' || this.$route.name === 'CustomerOrderEdit';
          },
          readOnlyOrder(){
              return this.currentOrderReadOnly;
          },
					newsIconClass(){
						let classes = "news-icon-button icon-btn pointer";
						if (this.currentUser.ShowRedNewsIcon) {
							classes += " color-red";
						}
						return classes;
					}
      },
      methods: {
          toggleDealerIconNav(){
              this.dealerIconNavOpen = !this.dealerIconNavOpen;

              if (this.dealerIconNavOpen) {
                this.refreshFavorites();
              }
          },
          triggerSaveEvent(){
            this.$store.dispatch('TOGGLE_SAVE_TRIGGER');
          },
          accessCoachPlus(iconObj){

            if (!this.customerJdeNumber) {
                this.$store.dispatch('ADD_NOTIFICATION', {text: 'Assign a customer and save worksheet to access Coach+', type: 'error'})
                return
            }

            let data={
                JdeNumber: this.customerJdeNumber,
            }
              UserService.hsusCoachPlus(data)
                .then(res => {
                    window.open(res, '_blank');
                })
                .catch(err => {
                    console.log('error', err);
                    this.$store.dispatch('ADD_NOTIFICATION', {text: 'Unable to access CoachPlus at this time', type: 'error'})
                })
          },
          goToMostRecentOrder(){
            OrderService.mostRecent()
                .then(res => {
                    if(this.$route.name === 'CustomerOrderEdit'){
                        this.$router.replace({ name: 'CustomerOrderEdit', params: { id: res.Id, cid: res.CustomerId } } );
                        this.$router.go();
                    }else {
                        this.$router.push({ name: 'CustomerOrderEdit', params: { id: res.Id, cid: res.CustomerId } } );
                    }
                })
                .catch(err => {
                    console.log(err)
                })
            },
          getCustomIcons(){
              let dealerId = this.currentUser.DealerId;
              if (!dealerId) return;
              DealerService.customIcons(dealerId).then(res => {
                  this.customIcons = res;
              }).catch(err => {
                  console.error(err);
              })
          },
          refreshFavorites() {
            this.$store.dispatch('UPDATE_FAVORITES');
          },
          navigateToFavorite(favorite) {
            const orderId = favorite.OrderId;
            const customerId = favorite.CustomerId;
            const routeData = this.$router.resolve({ name: 'CustomerOrderEdit', params: { id: orderId, cid: customerId } });
            window.location.href = routeData.href;
          },
					onNewsClick(){
						this.$store.dispatch('RESET_USER_REDNEWSICON');
						this.newsIconKey += 1;
						const win = window.open("http://dentacad.com/UserDocumentation/News/News.html", '_blank');
						win.focus();
					},
      },
      mounted(){
         this.getCustomIcons();
         this.refreshFavorites();

         this.isLimitedTransferUser = this.currentUser.IsLimitedTransferUser;
      }
    }
</script>

<style lang="scss" scoped>
.color-red {
	color: red!important;
}
.news-icon-button {
	display: flex;
	justify-content: center;
	align-content: center;
	margin: 8px 0px;
}

.sidebar-wrapper{
    display: flex;
    flex-direction: row;

  .sidebar{
      min-width: 50px;
      max-width: 50px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-content: center;
      background-color: $ss-blue-extra-light;
      .sidebar-top{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-content: center;
        .icon-btn{
            border: none;
            background-color: transparent;
            color: $primary;
            padding: 0px;
            font-size: 24px;
        }
        .save-btn {
            padding: 0px;
            font-size: 12px;
        }
        a{
        display: flex;
        justify-content: center;
        align-content: center;
        margin: 8px 0px;
        }
        i{
        font-size: 24px;
        }
        .home-link {
            margin: 0px !important;
        }
        .sidebar-icon-img {
            width: 42px;
            height: 42px;
            object-fit: contain;
            filter: brightness(0) saturate(100%) invert(12%) sepia(34%) saturate(2048%) hue-rotate(197deg) brightness(96%) contrast(93%);
        }
      }
      .sidebar-bottom{
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-content: center;
        .icon-btn{
            border: none;
            background-color: transparent;
            color: $primary;
            padding: 0px;
            font-size: 24px;
        }
        a{
            display: flex;
            justify-content: center;
            align-content: center;
            margin: 8px 0px;
        }
      }
  }

  .favorite-item {
    margin-bottom: 10px;
    cursor: pointer;
		font-size: 11pt;
		white-space: nowrap;
  }

  .favorites{
      min-width: 200px;
      max-width: 650px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-content: center;
      background-color: $ss-blue-extra-light;
      .sidebar-top{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-content: center;
        .icon-btn{
            border: none;
            background-color: transparent;
            color: $primary;
            padding: 0px;
            font-size: 24px;
        }
        .save-btn {
            padding: 0px;
            font-size: 12px;
        }
        a{
        display: flex;
        justify-content: center;
        align-content: center;
        margin: 8px 0px;
        }
        i{
        font-size: 24px;
        }
      }
      .sidebar-bottom{
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-content: center;
        .icon-btn{
            border: none;
            background-color: transparent;
            color: $primary;
            padding: 0px;
            font-size: 24px;
        }
        a{
            display: flex;
            justify-content: center;
            align-content: center;
            margin: 8px 0px;
        }
      }
  }
}
</style>
